import { render, staticRenderFns } from "./GireseDelegaciones.vue?vue&type=template&id=77809837&scoped=true&"
import script from "./GireseDelegaciones.vue?vue&type=script&lang=js&"
export * from "./GireseDelegaciones.vue?vue&type=script&lang=js&"
import style0 from "./GireseDelegaciones.vue?vue&type=style&index=0&id=77809837&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77809837",
  null
  
)

export default component.exports